import { combineReducers } from "redux";

import session from "./session/reducer";
import syndic from "./syndic/reducer";

export default combineReducers({
  session,
  syndic,
});
